/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destination_ChatInputs */



/**
* | output |
* | --- |
* | "Return it in the chat" |
*
* @param {Agent_Builder_Destination_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destination_chat = /** @type {((inputs?: Agent_Builder_Destination_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destination_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Chat zurückgeben")
	return /** @type {LocalizedString} */ ("Return it in the chat")
});